// extracted by mini-css-extract-plugin
export default {"search":"CategoriesSearch_search__-kbUH"};